(function(){
'use strict';
var productCache=new Map();
function storefrontRoot(){
 var s=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
 return s.endsWith('/')?s:s+'/';
}
function safeImage(image){
 var url=typeof image==='string'?image:(image&&typeof image==='object'?(image.src||image.url||''):'');
 if(typeof url!=='string'||!url)return '';
 if(url.startsWith('//'))url='https:'+url;
 try{var parsed=new URL(url,window.location.href);
  return parsed.protocol==='https:'||parsed.protocol==='http:'?parsed.href:'';
 }catch(e){return '';}
}
function shopifyPrice(cents){
 var n=Number(cents);
 if(!(n>0))return '';
 var currency=window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active||'TRY';
 try{if(currency==='TRY')return new Intl.NumberFormat('en-US',{minimumFractionDigits:0,maximumFractionDigits:2}).format(n/100)+'TL';return new Intl.NumberFormat('tr-TR',{style:'currency',currency:currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(n/100);}
 catch(e){return new Intl.NumberFormat('tr-TR',{maximumFractionDigits:2}).format(n/100)+' '+currency;}
}
function readProduct(handle){
 if(productCache.has(handle))return productCache.get(handle);
 var path=storefrontRoot()+'products/'+encodeURIComponent(handle)+'.js';
 var promise=fetch(path,{method:'GET',credentials:'same-origin',headers:{Accept:'application/json'}})
 .then(function(response){if(!response.ok)throw new Error('Ürün bulunamadı');return response.json();})
 .then(function(item){
  var options=Array.isArray(item.variants)?item.variants:[];
  var available=options.filter(function(v){return v.available&&Number(v.price)>0;});
  if(item.available===false||!available.length)throw new Error('Stokta yok');
  var picture=safeImage(item.featured_image||(item.images||[])[0]);
  var title=typeof item.title==='string'?item.title.trim():'';
  if(!picture||!title)throw new Error('Ürün görseli veya adı eksik');
  var cents=available.reduce(function(current,v){return Math.min(current,Number(v.price));},Infinity);
  var price=shopifyPrice(cents);
  if(!price)throw new Error('Fiyat doğrulanamadı');
  return {handle:handle,title:title,brand:item.vendor||'',price:price,image:picture,href:storefrontRoot()+'products/'+encodeURIComponent(handle)};
 }).catch(function(error){productCache.delete(handle);throw error;});
 productCache.set(handle,promise);
 return promise;
}
function updateProductNode(element,item){
 element.setAttribute('href',item.href);
 element.setAttribute('aria-label',item.title+' ürününü incele');
 var image=element.querySelector('img');
 if(image){
  image.removeAttribute('srcset');image.removeAttribute('sizes');
  image.setAttribute('src',item.image);
  image.setAttribute('alt',item.title);
  image.setAttribute('loading','lazy');
  image.setAttribute('decoding','async');
 }
 var vendor=element.querySelector('small'),title=element.querySelector('strong'),price=element.querySelector('b');
 if(vendor)vendor.textContent=item.brand;
 if(title)title.textContent=item.title;
 if(price)price.textContent=item.price;
}
function renderExtra(slot,items,staticCards){
 var card=slot.querySelector('[data-kdk-hero-dynamic-pair]');
 if(!card){
  if(!staticCards.length)throw new Error('Kart şablonu yok');
  card=staticCards[0].cloneNode(true);
  card.classList.remove('is-current');
  card.setAttribute('data-kdk-hero-dynamic-pair','');
  card.setAttribute('aria-hidden','true');card.setAttribute('inert','');
  card.removeAttribute('data-kdk-pair-phase');
  slot.appendChild(card);
 }
 var links=Array.prototype.slice.call(card.querySelectorAll('a.kdk-looks-product'));
 if(links.length!==2)throw new Error('Ürün şablonu beklenenden farklı');
 links.forEach(function(link,i){updateProductNode(link,items[i]);});
 card.setAttribute('aria-label',(items[0].brand||'Ürün')+' ve '+(items[1].brand||'ürün')+' kombinasyonu');
 return card;
}
function showCard(slot,card){
 Array.prototype.forEach.call(slot.querySelectorAll('[data-kdk-pair]'),function(node){
  var active=node===card;
  node.classList.toggle('is-current',active);
  node.setAttribute('aria-hidden',active?'false':'true');
  if(active)node.removeAttribute('inert');else node.setAttribute('inert','');
 });
}

var KDK_90D_ORDERS={"ugg-goldenstar-evelina-clog-burnt-cedar":39,"longchamp-le-pliage-green-m-tote-bag-mocha":20,"coach-nolita-19-in-signature-1":17,"ugg-goldenstar-evelina-clog":15,"on-cloudtilt-women-sneaker":13,"alo-yoga-suit-up-trouser-regular-1":13,"coach-teri-kadin-deri-canta":11,"coach-134":11,"ralph-lauren-logo-reversible-leather-skinny-belt-cift-tarafli-kadin-deri-kemer-2cm-black-lauren-tan":11,"coach-rainer-crossbody-bag-18-in-signature-gold-tan-brown":8,"new-balance-530-pumpernickel-sea-salt-newb-0017-24-0":7,"longchamp-le-pliage-green-s-handbag":5,"coach-medium-corner-zip-deri-kadin-cuzdan-2":4,"coach-snap-wallet-with-signature-gold-walnut-blac":4,"coach-erin-shoulder-bag-suede-gold-warm-brown":4,"ugg-womens-tazz-ii-color":4,"alo-yoga-suit-up-trouser-regular-espresso":4,"coach-mini-skinny-id-case-in-signature-5":3,"ralph-lauren-cable-knit-cotton-crewneck-sweater-collection-camel-melange":2,"on-cloudtilt-mens-sneaker-black-ivory":2};
var KDK_YEAR_ORDERS={"coach-nolita-19-in-signature-1":93,"ugg-womens-tazz-ii-color":71,"on-cloudtilt-women-sneaker":70,"ralph-lauren-logo-reversible-leather-skinny-belt-cift-tarafli-kadin-deri-kemer-2cm-black-lauren-tan":66,"coach-teri-kadin-deri-canta":64,"alo-yoga-suit-up-trouser-regular-1":50,"longchamp-le-pliage-green-m-tote-bag-mocha":45,"ugg-goldenstar-evelina-clog-burnt-cedar":39,"longchamp-le-pliage-green-s-handbag":28,"coach-medium-corner-zip-deri-kadin-cuzdan-2":21,"coach-snap-wallet-with-signature-gold-walnut-blac":14,"coach-134":15,"ugg-goldenstar-evelina-clog":15,"coach-mini-skinny-id-case-in-signature-5":8,"coach-rainer-crossbody-bag-18-in-signature-gold-tan-brown":8,"new-balance-530-pumpernickel-sea-salt-newb-0017-24-0":7,"coach-erin-shoulder-bag-suede-gold-warm-brown":4,"alo-yoga-suit-up-trouser-regular-espresso":13};
function choiceHandles(choice){
 if(choice.type==='extra')return choice.handles;
 return Array.prototype.slice.call(choice.card.querySelectorAll('a.kdk-looks-product')).map(function(link){
  var match=(link.getAttribute('href')||'').match(/\/products\/([^/?]+)/);
  return match?decodeURIComponent(match[1]):'';
 });
}
function salesPriority(choice){
 var handles=choiceHandles(choice);
 if(handles.length!==2||!handles.every(Boolean))return 0;
 var a=KDK_90D_ORDERS[handles[0]]||0,b=KDK_90D_ORDERS[handles[1]]||0;
 var annual=(KDK_YEAR_ORDERS[handles[0]]||0)+(KDK_YEAR_ORDERS[handles[1]]||0);
 return (a>=3&&b>=3?100000:0)+(a+b)*100+annual*.1;
}
var HISTORY_KEY='kdk-hero-variety-v1';
function readVisitHistory(){
 var history={slides:[],pairs:Object.create(null),lastStart:''};
 try{
  var saved=JSON.parse(window.localStorage.getItem(HISTORY_KEY)||'null');
  if(saved&&typeof saved.lastStart==='string')history.lastStart=saved.lastStart;
  if(saved&&Array.isArray(saved.slides))history.slides=saved.slides.filter(function(id){return typeof id==='string';}).slice(-20);
  if(saved&&saved.pairs&&typeof saved.pairs==='object')Object.keys(saved.pairs).slice(0,24).forEach(function(id){
   if(Array.isArray(saved.pairs[id]))history.pairs[id]=saved.pairs[id].filter(function(key){return typeof key==='string';}).slice(-100);
  });
 }catch(error){}
 return history;
}
function remember(list,key,limit){
 var previous=list.indexOf(key);
 if(previous!==-1)list.splice(previous,1);
 list.push(key);
 if(list.length>limit)list.splice(0,list.length-limit);
}
function pickInitialSlide(ids,recent,lastStart){
 var last=recent[recent.length-1];
 var candidates=ids.map(function(id,index){return {id:id,index:index,age:recent.indexOf(id),random:Math.random()};})
 .filter(function(item){return ids.length===1||item.id!==lastStart;});
 var notLast=candidates.filter(function(item){return item.id!==last;});
 if(notLast.length)candidates=notLast;
 candidates.sort(function(a,b){return a.age-b.age||a.random-b.random;});
 return candidates.length?candidates[0].index:0;
}
function rankedChoices(choices,recent,currentKey,otherStates){
 var excluded=new Set(),otherHandles=new Set();
 otherStates.forEach(function(state){
  [state.current,state.pending].forEach(function(choice){
   if(!choice)return;
   excluded.add(choice.key);
   choice.handles.forEach(function(handle){otherHandles.add(handle);});
  });
 });
 return choices.filter(function(choice){return !choice.disabled&&choice.key!==currentKey&&!excluded.has(choice.key);})
 .map(function(choice){return {choice:choice,overlap:choice.handles.filter(function(handle){return otherHandles.has(handle);}).length,
  age:recent.indexOf(choice.key),weight:Math.random()+Math.min(1,salesPriority(choice)/100000)*0.2};})
 .sort(function(a,b){return a.overlap-b.overlap||a.age-b.age||b.weight-a.weight;})
 .map(function(item){return item.choice;});
}
function setup(root){
 if(!root||root.dataset.kdkInitialized==='true')return;
 var slides=Array.prototype.slice.call(root.querySelectorAll('[data-kdk-rotator-slide]'));
 var back=root.querySelector('[data-kdk-rotator-prev]'),forward=root.querySelector('[data-kdk-rotator-next]');
 var status=root.querySelector('[data-kdk-rotator-status]');
 if(!slides.length||!back||!forward)return;
 root.dataset.kdkInitialized='true';root.dataset.ready='true';
 var activeIndex=0,timer=null,hover=false,focus=false,touch=false,touchResume=null;
 var reduced=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
 var interval=Math.max(10000,Number(root.dataset.interval)||12000);
 var manualPause=false,offscreen=false,destroyed=false;
 var pauseButton=root.querySelector('[data-kdk-cinema-pause]');
 var allExtra=window.KDK_HERO_PAIRED_LOOKS_V2||{};
 var history=readVisitHistory(),slideStates=[];
 var slideIds=slides.map(function(slide,index){return slide.getAttribute('data-kdk-hero-slide-id')||String(index);});
 function saveHistory(){try{window.localStorage.setItem(HISTORY_KEY,JSON.stringify(history));}catch(error){}}
 function noteShown(state,choice){
  if(!choice)return;
  if(!history.pairs[state.id])history.pairs[state.id]=[];
  remember(history.pairs[state.id],choice.key,100);saveHistory();
 }
 function isPaused(){return destroyed||manualPause||offscreen||document.hidden||hover||focus||touch||(reduced&&reduced.matches);}
 function stop(){if(timer!==null){clearTimeout(timer);timer=null;}root.dataset.running='false';}
 function schedule(){
  stop();
  if(isPaused()||slides.length<2)return;
  root.dataset.running='true';
  timer=setTimeout(function(){activate(activeIndex+1,false);},interval);
 }
 function resetButton(state){
  if(!state.button)return;
  state.button.hidden=state.choices.length<2;
  state.button.disabled=state.choices.length<2;
  state.button.removeAttribute('aria-busy');
  if(state.label)state.label.textContent=state.labelText;
 }
 function cancel(state){state.version++;state.working=false;state.pending=null;resetButton(state);}
 function valid(state,version){return !destroyed&&root.isConnected!==false&&!offscreen&&!document.hidden&&slides[activeIndex]===state.slide&&state.version===version;}
 async function refresh(state,manual){
  if(state.working||!valid(state,state.version))return;
  state.working=true;var version=++state.version;
  if(state.button){state.button.disabled=true;state.button.setAttribute('aria-busy','true');}
  if(state.label)state.label.textContent='Hazırlanıyor';
  var others=slideStates[activeIndex].filter(function(item){return item!==state;});
  var candidates=rankedChoices(state.choices,history.pairs[state.id]||[],state.current&&state.current.key,others);
  try{
   var probes=0;
   for(var i=0;i<candidates.length&&probes<6;i++){
    if(!valid(state,version))return;
    var pick=candidates[i];
    if(others.some(function(other){return other.current&&other.current.key===pick.key||other.pending&&other.pending.key===pick.key;}))continue;
    probes++;state.pending=pick;
    try{
     var items=await Promise.all(pick.handles.map(readProduct));
     if(!valid(state,version))return;
     if(others.some(function(other){return other.current&&other.current.key===pick.key;})){state.pending=null;continue;}
     var card=renderExtra(state.slot,items,state.templates);
     showCard(state.slot,card);state.current=pick;state.needsHydration=false;
     state.slot.dataset.kdkCurrent=String(state.choices.indexOf(pick));
     noteShown(state,pick);
     if(manual&&status)status.textContent='Yeni kombin gösteriliyor';
     break;
    }catch(error){
     if(!valid(state,version))return;
     pick.disabled=true;
    }
    state.pending=null;
   }
   if(valid(state,version))state.needsHydration=false;
  }finally{
   if(state.version===version){state.pending=null;state.working=false;resetButton(state);schedule();}
  }
 }
 function hydrateVisible(){
  if(offscreen||document.hidden||destroyed)return;
  (slideStates[activeIndex]||[]).forEach(function(state){if(state.needsHydration)refresh(state,false);});
 }
 function activate(index,manual){
  activeIndex=(index+slides.length)%slides.length;
  slides.forEach(function(slide,i){
   var active=i===activeIndex;
   slide.classList.toggle('is-active',active);slide.classList.remove('is-showcase');
   slide.setAttribute('aria-hidden',active?'false':'true');
   if(active)slide.removeAttribute('inert');else slide.setAttribute('inert','');
   if(!active)slideStates[i].forEach(cancel);
  });
  remember(history.slides,slideIds[activeIndex],20);saveHistory();
  slideStates[activeIndex].forEach(function(state){
   state.needsHydration=!state.current;
   noteShown(state,state.current);
   state.slot.querySelectorAll('.is-current img').forEach(function(img){img.loading='eager';});
  });
  root.dataset.slideIndex=String(activeIndex);
  if(manual&&status)status.textContent=(activeIndex+1)+'. seçki: '+(slides[activeIndex].dataset.slideTitle||'Koleksiyon');
  hydrateVisible();schedule();
 }
 slides.forEach(function(slide,slideIndex){
  var id=slideIds[slideIndex],list=allExtra[id]||[[],[]];
  var slots=Array.prototype.slice.call(slide.querySelectorAll('[data-kdk-look-slot]'));
  var templates=Array.prototype.slice.call(slide.querySelectorAll('[data-kdk-pair]'));
  var union=[];
  list.forEach(function(group){if(Array.isArray(group))union=union.concat(group);});
  templates.forEach(function(card){union.push(choiceHandles({type:'static',card:card}));});
  var states=[];
  slots.forEach(function(slot){
   var staticCards=Array.prototype.slice.call(slot.querySelectorAll('[data-kdk-pair]'));
   var choices=[],used=new Set();
   function addChoice(pair,card){
    if(!Array.isArray(pair)||pair.length!==2||pair[0]===pair[1]||!pair.every(function(handle){return typeof handle==='string'&&handle.length>0;}))return;
    var key=pair.slice().sort().join('|');if(used.has(key))return;
    used.add(key);choices.push({type:'extra',handles:pair.slice(),key:key,card:card||null,disabled:false});
   }
   staticCards.forEach(function(card){addChoice(choiceHandles({type:'static',card:card}),card);});
   union.forEach(function(pair){addChoice(pair);});
   var fallback=choices.find(function(choice){return choice.card&&!states.some(function(other){return other.current&&other.current.key===choice.key;});});
   if(fallback)showCard(slot,fallback.card);
   var button=slot.querySelector('[data-kdk-look-swap]'),label=button&&button.querySelector('span:first-child');
   var state={id:id,slide:slide,slot:slot,choices:choices,templates:staticCards.length?staticCards:templates,current:fallback||null,pending:null,
    version:0,working:false,needsHydration:true,button:button,label:label,labelText:label&&label.textContent||'Başka kombin'};
   states.push(state);slot.dataset.kdkLookCount=String(choices.length);resetButton(state);
   if(button)button.addEventListener('click',function(){refresh(state,true);});
  });
  slideStates.push(states);
 });
 if(pauseButton)pauseButton.addEventListener('click',function(){
  manualPause=!manualPause;
  pauseButton.setAttribute('aria-pressed',String(manualPause));
  pauseButton.setAttribute('aria-label',manualPause?'Animasyonu oynat':'Animasyonu duraklat');
  pauseButton.querySelector('span').textContent=manualPause?'▷':'Ⅱ';
  schedule();
 });
 if(typeof IntersectionObserver!=='undefined'){
  var visibilityObserver=new IntersectionObserver(function(entries){
   offscreen=!entries[0].isIntersecting;
   if(offscreen)slideStates[activeIndex].forEach(cancel);else hydrateVisible();
   schedule();
  },{threshold:.1});
  visibilityObserver.observe(root);
  document.addEventListener('shopify:section:unload',function(e){if(e.target.contains(root)){destroyed=true;slideStates.forEach(function(states){states.forEach(cancel);});stop();visibilityObserver.disconnect();}},{once:true});
 }
 back.addEventListener('click',function(){activate(activeIndex-1,true);});
 forward.addEventListener('click',function(){activate(activeIndex+1,true);});
 root.addEventListener('pointerenter',function(e){if(e.pointerType==='mouse'||e.pointerType==='pen'){hover=true;stop();}});
 root.addEventListener('pointerleave',function(e){if(e.pointerType==='mouse'||e.pointerType==='pen'){hover=false;schedule();}});
 root.addEventListener('focusin',function(){focus=true;stop();});
 root.addEventListener('focusout',function(){setTimeout(function(){focus=root.contains(document.activeElement);if(!focus)schedule();},0);});
 root.addEventListener('touchstart',function(){touch=true;stop();clearTimeout(touchResume);},{passive:true});
 function touchEnd(){clearTimeout(touchResume);touchResume=setTimeout(function(){touch=false;schedule();},3600);}
 root.addEventListener('touchend',touchEnd,{passive:true});
 root.addEventListener('touchcancel',touchEnd,{passive:true});
 document.addEventListener('visibilitychange',function(){
  if(document.hidden){slideStates[activeIndex].forEach(cancel);stop();}else{hydrateVisible();schedule();}
 });
 if(reduced&&reduced.addEventListener)reduced.addEventListener('change',schedule);
 var initialIndex=Math.max(0,slideIds.indexOf('kdk_luxe_slide_season'));
  // Open on the established bestseller pair; retain other slides for subsequent rotation.
 history.lastStart=slideIds[initialIndex];
 activate(initialIndex,false);
}
function initialize(){document.querySelectorAll('[data-kdk-rotator]').forEach(setup);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
document.addEventListener('shopify:section:load',initialize);
})();


